import type { JSX } from 'react';

import { cn } from '@/lib/utils';

import type { AlertActionStatus } from '../../types/alertsConfig';

interface AlertActionBadgeProps {
  status: AlertActionStatus;
  label: string;
}

const statusStyles: Record<AlertActionStatus, string> = {
  active: 'bg-success/10 text-success',
  scoped: 'bg-primary/10 text-primary',
  legacy: 'bg-amber-100 text-amber-700',
};

const AlertActionBadge = ({ status, label }: AlertActionBadgeProps): JSX.Element => (
  <span className={cn('inline-block shrink-0 rounded-full px-2.5 py-0.5 text-[11px] font-bold', statusStyles[status])}>
    {label}
  </span>
);

export default AlertActionBadge;
